module.exports = __webpack_public_path__ + "img/dz.0ffabba4.svg";